function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import { css, color } from "../../../../styles/theme";
import SvgButton from "../../../basic/SvgButton";
import { SvgClose, SvgSearch } from "../../../../svg";
import { default as Styles } from "./ToolbarTableStyles";
var SearchBar = /*#__PURE__*/function (_React$Component) {
  function SearchBar(props, context) {
    var _this;
    _classCallCheck(this, SearchBar);
    _this = _callSuper(this, SearchBar, [props, context]);
    _defineProperty(_this, "inputElement", void 0);
    _this.state = {
      focus: false
    };
    return _this;
  }
  _inherits(SearchBar, _React$Component);
  return _createClass(SearchBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var focus = this.state.focus;
      if (focus) {
        this.inputElement.focus(); // Re-focus if already in focus when update
      }
    }
  }, {
    key: "clearInput",
    value: function clearInput() {
      var onUpdate = this.props.onUpdate;
      onUpdate(''); // Clear the input with empty string
      this.inputElement.focus(); // Focus again after clear all
    }
  }, {
    key: "handleInputKeyDown",
    value: function handleInputKeyDown(key) {
      if (key === 'Escape') {
        this.clearInput(); // When escape pressed, clear the input
      }
    }
  }, {
    key: "handleClearAllKeyPress",
    value: function handleClearAllKeyPress(key) {
      if (key === 'Enter' || key === ' ') {
        this.clearInput();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        value = _this$props.value,
        placeholder = _this$props.placeholder,
        onUpdate = _this$props.onUpdate;
      var focus = this.state.focus;
      var primaryText = color.primaryText,
        danger = color.danger;
      var title = 'Clear input';
      var displayValue = value || '';
      var hasValue = displayValue !== '';
      // Account for placeholder translations passed as functions.
      var placeholderText = typeof placeholder === 'function' ? placeholder() : placeholder;
      return /*#__PURE__*/React.createElement("div", _extends({}, css(Styles.searchBarWrapper, focus && Styles.focused, 'cui-searchBarWrapper'), {
        onClick: function onClick() {
          return _this2.setState({
            focus: true
          });
        }
      }), /*#__PURE__*/React.createElement("div", css(Styles.searchBarIconWrapper, Styles.iconWrapper, 'cui-searchBarIconWrapper', 'cui-iconWrapper'), /*#__PURE__*/React.createElement(SvgSearch, {
        size: 18
      })), /*#__PURE__*/React.createElement("input", _extends({}, css(Styles.searchBarInput, 'cui-searchBarInput'), {
        ref: function ref(_ref) {
          return _this2.inputElement = _ref;
        },
        value: displayValue,
        placeholder: placeholderText,
        onChange: function onChange(event) {
          return onUpdate(event.target.value);
        },
        onFocus: function onFocus() {
          return _this2.setState({
            focus: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            focus: false
          });
        },
        onKeyDown: function onKeyDown(event) {
          return _this2.handleInputKeyDown(event.key);
        }
      })), /*#__PURE__*/React.createElement(SvgButton, {
        size: "sm",
        type: "icon",
        style: {
          display: hasValue ? 'block' : 'none'
        },
        htmlAttributes: {
          tabIndex: 0,
          title: title
        },
        onClick: function onClick() {
          return _this2.clearInput();
        },
        svgElement: /*#__PURE__*/React.createElement(SvgClose, {
          size: 15,
          title: title,
          hoverColor: danger
        })
      }));
    }
  }]);
}(React.Component);
export default SearchBar;